// frontend/api/lookups.js
import api from "./api";

export const DepartmentsAPI = {
  list: () => api("/departments"),
};

export const UsersAPI = {
  list: () => api("/users"),
};

export const SchoolsAPI = {
  list: () => api("/schools"),
};

export const CategoriesAPI = {
  list: (departmentId) =>
    departmentId
      ? api(`/categories?department_id=${departmentId}`)
      : api("/categories"),
};

export const SubcategoriesAPI = {
  list: (categoryId) =>
    categoryId
      ? api(`/categories/${categoryId}/subcategories`)
      : api(`/subcategories`),
};